export function validate(record){
        return Promise.resolve({record});
    }
    